import React from 'react';
import { Box } from '@mui/material';
import { FaChartBar, FaCalendar } from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import GeneralResultsWrapper from './GeneralResults/index';
import SchedulingWrapper from './Scheduling';

const menus = [
    {
        title: 'Resultados Gerais',
        path: '/governanceroom/dashboardproductionesus/general-results/results',
        icon: <FaChartBar style={{ marginRight: '5px' }} />
    },
    {
        title: 'Agendamentos',
        path: '/governanceroom/dashboardproductionesus/general-results/scheduling',
        icon: <FaCalendar style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardproductionesus/general-results/results':
        'Resultados Gerais dos Indicadores',
    '/governanceroom/dashboardproductionesus/general-results/scheduling':
        'Resultados Gerais dos Agendamentos'
};

const GeneralResults = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardproductionesus');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="results" replace />}
                        />
                        <Route
                            path="results"
                            element={<GeneralResultsWrapper />}
                        />
                        <Route
                            path="scheduling"
                            element={<SchedulingWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default GeneralResults;
